import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {SchoolModel} from '../../../../models/school/school.model';
import {AdminSchoolService} from '../../../../services/admin/admin-school.service';
import {AdminOrganizationService} from '../../../../services/admin/admin-organization.service';
import {OrganizationModel, OrganizationFilter} from '../../../../models/school/organization.model';
import {CountryModel} from '../../../../models/localization-and-pricing/country.model';
import {CultureModel} from '../../../../models/localization-and-pricing/culture.model';
import {ModalService} from '../../../../shared/modals/modal/modal.service';
import {ErrorModel} from '../../../../models/shared/error.model';

@Component({
  selector: 'app-evo-admin-school-settings',
  templateUrl: './evo-admin-school-settings.component.html',
  styleUrls: ['./evo-admin-school-settings.component.css']
})
export class EvoAdminSchoolSettingsComponent implements OnInit {

  schoolId: string;
  school: SchoolModel;
  Countries = CountryModel.privateDropdownList();
  Cultures = CultureModel.privateDropdownList();

  updatingSchool = false;
  deletingSchool = false;

  excludeBusinessMetrics: boolean;
  isTestSchool;

  password = '';
  secret = '';

  showOrgPicker = false;
  orgSearchQuery = '';
  orgSearchResults: OrganizationModel[] = [];
  isSearchingOrg = false;
  isUpdatingOrg = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private modalSv: ModalService,
              private schoolSv: AdminSchoolService,
              private organizationSv: AdminOrganizationService) { }

  ngOnInit() {

    this.route.parent.params.subscribe((params: Params) => {

      this.schoolId = params.schoolId;
      this.fetchSchool();

    });

  }

  fetchSchool() {

    this.schoolSv.fetchSchoolById(this.schoolId).subscribe((school) => {
      this.school = school;
      this.excludeBusinessMetrics = school.excludeFromBusinessMetrics;
      this.isTestSchool = school.isTestSchool;
    });

  }

  onSaveClicked() {

    this.updatingSchool = true;
    this.schoolSv.updateSchool(this.school).subscribe((school) => {
      this.updatingSchool = false;
      this.modalSv.showAlertModal('Success', 'School update successfully');
    }, (err: ErrorModel) => {
      this.updatingSchool = false;
      this.modalSv.showTranslatedErrorModal(err);
    });

  }

  onExcludeBusinessMetricsClicked() {

    this.school.excludeFromBusinessMetrics = this.excludeBusinessMetrics;
    this.onSaveClicked();

  }

  onIsTestSchoolClicked() {

    this.school.isTestSchool = this.isTestSchool;
    if (this.isTestSchool) {
      this.school.excludeFromBusinessMetrics = true;
    }

    this.onSaveClicked();

  }

  openOrgPicker() {
    this.showOrgPicker = true;
    this.orgSearchQuery = '';
    this.searchOrganizations('');
  }

  closeOrgPicker() {
    this.showOrgPicker = false;
  }

  searchOrganizations(query: string) {
    this.orgSearchQuery = query;
    this.isSearchingOrg = true;
    const filter = new OrganizationFilter();
    filter.name = query || undefined;
    filter.limit = 20;
    this.organizationSv.getOrganizations(filter).subscribe(organizations => {
      this.orgSearchResults = organizations;
      this.isSearchingOrg = false;
    }, () => {
      this.isSearchingOrg = false;
    });
  }

  selectOrganization(organization: OrganizationModel) {
    this.isUpdatingOrg = true;
    this.organizationSv.addSchoolToOrganization(organization._id, this.school._id).subscribe(result => {
      this.isUpdatingOrg = false;
      this.school.organizationId = result.school.organizationId;
      this.school.organizationName = result.school.organizationName;
      this.showOrgPicker = false;
    }, (err: ErrorModel) => {
      this.isUpdatingOrg = false;
      this.modalSv.showTranslatedErrorModal(err);
    });
  }

  removeFromOrganization() {
    this.modalSv.showChoiceModal('Remove from organization', `Remove ${this.school.name} from ${this.school.organizationName}?`).subscribe(confirmed => {
      if (!confirmed) {
        return;
      }
      this.isUpdatingOrg = true;
      this.organizationSv.removeSchoolFromOrganization(this.school.organizationId, this.school._id).subscribe(result => {
        this.isUpdatingOrg = false;
        this.school.organizationId = result.school.organizationId;
        this.school.organizationName = result.school.organizationName;
      }, (err: ErrorModel) => {
        this.isUpdatingOrg = false;
        this.modalSv.showTranslatedErrorModal(err);
      });
    });
  }

  onDeleteClicked() {

    this.deletingSchool = true;
    this.modalSv.showChoiceModal('Warning', `Are you sure you want to delete ${this.school.name}`).subscribe((success) => {

      if (success) {
        this.schoolSv.deleteSchool(this.school._id, this.password, this.secret).subscribe((school) => {
          this.deletingSchool = false;
          this.modalSv.showAlertModal('Success', 'School deletion successful').subscribe(() => {
            this.router.navigate(['admin', 'schools']);
          });

        }, (err: ErrorModel) => {
          this.deletingSchool = false;
          this.modalSv.showTranslatedErrorModal(err);
        });
      }

    });

  }

}
